import { MapPin } from "lucide-react";
import andreasPortrait from "@/assets/andreas.jpg";

export const About = () => (
  <section id="about" data-testid="about-section" className="section-pad bg-white">
    <div className="container-tn">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-3 order-2 lg:order-1">
          <span className="eyebrow">About</span>
          <span className="gold-rule" />
          <h2 className="font-serif text-navy uppercase text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            Meet Andreas Aigner.
          </h2>
          <div className="mt-6 space-y-5 text-mutedink text-base sm:text-lg leading-relaxed">
            <p>
              Andreas is a commissioned Illinois Notary Public offering reliable, punctual mobile
              notary service across the western and northwest Chicago suburbs.
            </p>
            <p>
              Whether it&apos;s a single signature at your kitchen table or a full loan package at your
              office, he brings the same careful, professional approach every time — with clear
              pricing agreed before the visit.
            </p>
            <p>
              Based in River Grove, he keeps flexible hours so notarizations fit around your day —
              not the other way around.
            </p>
            <p data-testid="about-bilingual-line">
              Bilingual service available — English and Deutsch spoken.
            </p>
          </div>
          <div className="mt-8 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-surface border border-gold-soft/60 text-sm text-navy">
            <MapPin className="w-4 h-4 text-gold" />
            River Grove, IL 60171 · Serving the western &amp; northwest suburbs
          </div>
        </div>

        <div className="lg:col-span-2 order-1 lg:order-2">
          <div className="relative">
            <div className="absolute -inset-2 border-2 border-gold/60 rounded-md -z-0" aria-hidden="true" />
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-md ring-1 ring-navy/10">
              <img
                src={andreasPortrait}
                alt="Andreas Aigner, Illinois Notary Public"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
